// extracted by mini-css-extract-plugin
var _1 = "TestInfoItem_item__7c98b";
var _2 = "TestInfoItem_mask__6869e";
var _3 = "TestInfoItem_test-info-item__3d5fe";
var _4 = "TestInfoItem_test-info-item--isVisible--false__7fbb5";
var _5 = "TestInfoItem_test-info-item__icon__5b534";
var _6 = "TestInfoItem_test-info-item__img__8cf6a";
export { _1 as "item", _2 as "mask", _3 as "test-info-item", _4 as "test-info-item--isVisible--false", _5 as "test-info-item__icon", _6 as "test-info-item__img" }
